<template>
  <div>
      <modal-login v-if="modalShow.login" ></modal-login>
      <modal-add-carrinho v-if="modalShow.addCarrinho" ></modal-add-carrinho>
      <modal-add-carrinho-pizza ></modal-add-carrinho-pizza>
      <modal-add-carrinho-clone ></modal-add-carrinho-clone>
      <modal-endereco v-if="modalShow.endereco" ></modal-endereco>
      <modal-finalizar-compra v-if="modalShow.finalizarCompra"  ></modal-finalizar-compra>
  </div>
</template>

<script>
export default {

    methods: {

    },

// created () {

//     $("#modalEndereco").on("hidden.bs.modal", function () {
//         await this.$store.dispatch('hideAllModals').then();
//     });
// },


    computed: {
        modalShow() {
            return this.$store.state.modals.main;
        },
    },

    mounted() {

    }


}

</script>

<style>

</style>
